import React, { Dispatch, SetStateAction } from 'react';
import { Route, Routes } from 'react-router-dom';
import ForgotPassword from './ForgotPassword';
import Login from './Login';
import Migration from './Migration';
import SignUp from './SignUp';
import Seminar from '../seminar/Seminar';

type Props = {
  setAppLoading: Dispatch<SetStateAction<boolean>>;
  theme: 'light' | 'dark';
  authState?: string;
};

const LoggedOut: React.FC<Props> = ({ setAppLoading, theme, authState }) => {
  return (
    <>
      {/* <div className="bg-primary-600">
        <div className="px-3 py-3 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between">
            <div className="flex items-center flex-1 w-0">
              <span className="flex p-2 rounded-lg bg-primary-800">
                <MegaphoneIcon
                  className="w-6 h-6 text-white"
                  aria-hidden="true"
                />
              </span>
              <p className="ml-3 font-medium text-white">
                <span className="inline">
                  Uh oh! Our back-end system, Amazon Web Services, is
                  experiencing a service outage. This outage is wide-spread and
                  impacting multiple online platforms. We apologize for the
                  temporary inconvenience.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div> */}
      {/* <AuthFix
        hideDefault
        onStateChange={(state: any, data: any) => {
          setAuthState(state === 'verifyContact' ? 'signedIn' : state);
          if (state === 'signedIn' || state === 'verifyContact') {
            setAppLoading(false);
          }
          setUser(data);
        }}
      > */}
      <Routes>
        <Route path="/" element={<Login authState={authState} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/sign-up"
          element={<SignUp setAppLoading={setAppLoading} theme={theme} />}
        />
        <Route path="/seminar" element={<Seminar />} />
        <Route path="/migration" element={<Migration />} />
        <Route path="*" element={<Login authState={authState} />} />
      </Routes>
      {/* </AuthFix> */}
    </>
  );
};

export default LoggedOut;
